import React from 'react';

export function Icon({ name = 'arrow', size = 20, ...rest }) {
  const paths = {
    arrow: 'M4 12h15m-6-6 6 6-6 6',
    check: 'm5 12 4 4L19 6',
    plus: 'M12 5v14M5 12h14',
    close: 'm6 6 12 12M6 18 18 6',
    spark: 'm12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z',
    file: 'M7 3h7l4 4v14H5V3h2m7 0v5h4M8 12h7M8 16h7',
    play: 'm9 5 11 7-11 7Z',
    users:
      'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M17 4a4 4 0 0 1 0 8M22 21v-2a4 4 0 0 0-3-3.9M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
    chart: 'M4 3v17h17M8 15l4-5 4 2 5-8',
    shield: 'M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6Z',
    clock: 'M12 8v5l3 2M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
    globe:
      'M2 12h20M12 2a17 17 0 0 1 0 20 17 17 0 0 1 0-20m10 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
    download: 'M12 3v12m-5-5 5 5 5-5M5 17v4h14v-4',
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={paths[name] || paths.arrow} />
    </svg>
  );
}
export const Eyebrow = ({ children }) => <p className="ul-eyebrow">{children}</p>;
export const CheckList = ({ items }) => (
  <ul className="ul-checklist">
    {items.map((item) => (
      <li key={item}>
        <Icon name="check" size={18} />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);
export function Action({ children, onClick, secondary = false, light = false, ...rest }) {
  return (
    <button
      type="button"
      className={`ul-button ${secondary ? 'ul-button--secondary' : ''} ${light ? 'ul-button--light' : ''}`}
      onClick={onClick}
      {...rest}
    >
      {children}
      <Icon size={18} />
    </button>
  );
}
export function SectionHead({ eyebrow, title, children, center = false }) {
  return (
    <div className={`ul-section-head ${center ? 'ul-section-head--center' : ''}`}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2>{title}</h2>
      {children && <p className="ul-lead">{children}</p>}
    </div>
  );
}

/** Viewport framing only. Original media is unchanged and remains inspectable. */
export function ProductFrame({
  src,
  alt,
  width,
  height,
  crop,
  caption,
  className = '',
  eager = false,
}) {
  const [x, y, w, h] = crop || [0, 0, width, height];
  return (
    <figure className={`ul-product-frame ${className}`}>
      <div className="ul-browserbar" aria-hidden="true">
        <i />
        <i />
        <i />
        <span>Unity Learning</span>
      </div>
      <div className="ul-crop" style={{ aspectRatio: `${w}/${h}` }}>
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          style={{
            width: `${(width / w) * 100}%`,
            maxWidth: 'none',
            left: `${(-x / w) * 100}%`,
            top: `${(-y / h) * 100}%`,
          }}
        />
      </div>
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
